export default "__VITE_ASSET__BxE83d9q__"